exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ui.multiple.selection.dropdown > .ui.label {\n  font-size: 11px;\n  color: #696f89;\n  font-weight: 600;\n}\n", ""]);
